import { render, staticRenderFns } from "./dashboards1.vue?vue&type=template&id=a58302c6&scoped=true&"
import script from "./dashboards1.vue?vue&type=script&lang=js&"
export * from "./dashboards1.vue?vue&type=script&lang=js&"
import style0 from "./../assets/style1.css?vue&type=style&index=0&id=a58302c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58302c6",
  null
  
)

export default component.exports